import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { API_URL } from '../../Actions/Config'
import PhotoGallery from "../Common/Gallery"
import DatePicker from "react-datepicker";
import AOS from "aos";
import Header from '../Common/Header'
import Footer from '../Common/Footer'
import Helmet from '../Common/Helmet'
import TourListing from "../Common/TourListing"
import { getThingsToDoDetails } from "../../Actions/TourDetailsAction"
import { tourFb, tourTw, tourLn } from "../../Images"
import "aos/dist/aos.css";
import "../../css/mainUpdate.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "react-datepicker/dist/react-datepicker.css";

const mapStateToProps = (state) => {
    return {
        tourDetailsReducer: state.TourDetailsReducer
    }
}

const mapDispatchToProps = dispatch => ({
    getThingsToDoDetails: (name) => dispatch(getThingsToDoDetails(name))
});


function getURL(tour) {
    var url = ""
    url = "/day-tours/" + tour.permalink + "/" + tour.id
    return url
}


function getLocation(tour) {
    var location = "colombo"
    if (tour.location != null) {
        location = tour.location
    } else if (tour.city_excursion.length > 0) {
        location = tour.city_excursion[0]?.city.name
    }

    return location
}

function getImageURL(url, type = 0) {
    var image = ""

    switch (type) {
        case 0:
            image = API_URL + "/" + url
            break;

        default:
            break;
    }

    return image
}


function getBannerImages(tour) {
    var image = []
    if (tour != null) {
        image = [
            API_URL + "/" + tour.slider_img1,
            API_URL + "/" + tour.slider_img2,
            API_URL + "/" + tour.slider_img3,
            API_URL + "/" + tour.slider_img4,
            API_URL + "/" + tour.slider_img5
        ].filter(Boolean);
    }

    return image
}



const options = {
    items: 1,
    autoplay: true,
    autoplayTimeout: 3000,
    dots: true,
    nav: false
}


const buildUrl = (url, parameters) => {
    var qs = "";
    for (var key in parameters) {
        var value = parameters[key];
        if (!value) {
            continue
        }
        value = value.toString().split('\"').join('"');
        qs += key + "=" + encodeURIComponent(value) + "&";
    }
    if (qs.length > 0) {
        qs = qs.substring(0, qs.length - 1); //chop off last "&"
        url = url + "?" + qs;
    }
    return url;
}
const windowName = `sbg-window-${Math.random()}`;

const height = 400;
const width = 400;

const top = Math.max(0, (window.screen.height - height) / 2);
const left = Math.max(0, (window.screen.width - width) / 2);

const specs = `
      height=${height},
      width=${width},
      top=${top},
      left=${left},
      status=0,
      toolbar=0,
      directories=0,
      location=0,
      menubar=0,
      resizable=1,
      scrollbars=1`



class ThingsToDoDetails extends Component {

    constructor(props) {
        super(props);

        const { peram } = this.props.match.params;
        this.state = {
            categories: [],
            locations: []
        }
        this.props.getThingsToDoDetails(peram)
    }
    componentDidUpdate(prevProps) {
        if (
            prevProps.tourDetailsReducer.tour !== this.props.tourDetailsReducer.tour &&
            this.props.tourDetailsReducer.tour
        ) {
            const { images, tour, str_counts, categories, related_tours, new_cities } = this.props.tourDetailsReducer;

            this.setState({
                categories: typeof categories === "object" ? Object.values(categories) : [],
                locations: typeof new_cities === "object" ? Object.values(new_cities) : []
            });
        }
    }

    handleFbShare = () => {
        const url = buildUrl('https://www.facebook.com/sharer/sharer.php', {
            'u': document.URL
        });
        window.open(url, windowName, specs);
    }

    handleTwitterShare = () => {
        const url = buildUrl('http://twitter.com/intent/tweet', {
            'url': document.URL
        });
        window.open(url, windowName, specs);
    }

    handleLinkedInShare = () => {
        const url = buildUrl('http://www.linkedin.com/shareArticle', {
            'mini': 'true',
            'url': document.URL
        });
        window.open(url, windowName, specs);
    }


    render() {

        const { images, tour, str_counts, related_tours } = this.props.tourDetailsReducer;
        var state = this.state

        const banners = getBannerImages(tour)

        return <Fragment>
            <Header home={false} />
            <Helmet
                title={"Tour List"}
                description={"Listing"}
            />
            <div className='tour-details'>
                {tour != null ?
                    <div className='main-container'>

                        <div className="page-title">
                            <div className="container title-cont">
                                <div className="row">
                                    <div className="col-lg-12 title-inner tour-details-breadcrumb">
                                        <div className="breadcrumb-links">
                                            <a href="/">Home</a>
                                            <span className="sep"></span>
                                            <a href="/things-to-do">Things To Do </a>
                                            <span className="sep"></span>
                                            <a>{tour.name}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="contentwrap">
                            <div className="introwrap">
                                <div className="tour-content-wrap">
                                    <div className='container'>
                                        <div className='row'>
                                            <div class="col-12 tour-sub-heading">
                                                <div class="tour-page-title">
                                                    <h4>{tour.name}</h4>
                                                </div>

                                            </div>

                                            <div className="col-lg-9 tours-wrap">
                                                <div className="tour-details-wrap">
                                                    <div className="slider-section-detail-page">
                                                        <div className="single-page" >
                                                            {banners.length > 0 ? (<PhotoGallery
                                                                key={tour.id + "-" + banners.length}
                                                                images={banners}
                                                            />
                                                            ) : null}
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div className='col-lg-4 search-side'>
                                                            <div className="tour-searchwrap">
                                                                <div className="tour-search-title">
                                                                    <h4>Location</h4>
                                                                </div>
                                                                <br />
                                                                <div className="form-inner">
                                                                    <div className="travel-duration-wrap">
                                                                        <div className="form-group">
                                                                            <div className="select-drop-arrow"></div>
                                                                            <select name="duration" className="form-control" type="text">
                                                                                <option data-div="full" value="">All</option>
                                                                                {state.locations.length > 0 ? state.locations.map((loc) => (
                                                                                    <option data-div="full" value={loc[0]}>{loc[1]}</option>
                                                                                )) : null}
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                    <br />
                                                                </div>
                                                            </div>


                                                            <div className="tour-searchwrap">
                                                                <div className="tour-search-title">
                                                                    <h4>Category</h4>
                                                                </div>
                                                                <br />
                                                                <div className="form-inner">
                                                                    <div className="travel-duration-wrap">


                                                                        <div className="form-group">
                                                                            <div className="select-drop-arrow"></div>
                                                                            <select name="duration" className="form-control" type="text">
                                                                                <option data-div="full" value=""> Select Category </option>
                                                                                {state.categories.length > 0 ? state.categories.map((cat) => (
                                                                                    <option data-div="full" value={cat.id}>{cat.name}</option>
                                                                                )) : null}
                                                                            </select>
                                                                        </div>

                                                                    </div>
                                                                    <br />
                                                                </div>
                                                            </div>
                                                            <button type="submit" className="btn tour">SEARCH</button>
                                                        </div>
                                                        <div className='col-lg-8 col-md-9 col-12'>
                                                            <p> <div dangerouslySetInnerHTML={{ __html: tour.description }} /></p>
                                                            {related_tours.length > 0 ? <div class="related-tours-wrap">
                                                                <h4>Related Tours</h4>

                                                                <div class="related-tour-lists">
                                                                    {related_tours.map((tour, tIndex) => (<div class="rt-wrapper" key={tIndex}>
                                                                        <div class="rt-info">
                                                                            <a href={getURL(tour)}>
                                                                                <h6>{tour.title}</h6>
                                                                            </a>
                                                                            {tour.location?.name}
                                                                        </div>

                                                                    </div>))}

                                                                </div>
                                                            </div> : null}
                                                        </div>
                                                    </div>



                                                </div>
                                            </div>

                                            <div className="col-lg-3 col-priceform pr-gap">

                                                <div class="price-contents">
                                                    <div className='maptani rm-pad'>
                                                        <iframe
                                                            width="100%"
                                                            height="400"
                                                            loading="lazy"
                                                            allowFullScreen
                                                            src={`https://maps.google.com/maps?q=${getLocation(tour)}&t=&z=13&ie=UTF8&iwloc=&output=embed`}
                                                        ></iframe>
                                                    </div>
                                                    <div class="price-form">
                                                        <div class="socialwrap">
                                                            <h4>Share Tour with Friends</h4>
                                                            <ul>
                                                                <script src='https://connect.facebook.net/en_US/all.js'></script>
                                                                <li onClick={this.handleFbShare}><a id="fb_share"><img src={tourFb} alt="" width="23" height="23" /></a></li>
                                                                <li onClick={this.handleTwitterShare}><a id="twitter_share"><img src={tourTw} alt="" width="23" height="23" /></a></li>
                                                                <li onClick={this.handleLinkedInShare}><a id="linkedin_share"><img src={tourLn} alt="" width="23" height="23" /></a></li>
                                                            </ul>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : null}
            </div>
            <Footer hyperLink={true} />
        </Fragment>
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(ThingsToDoDetails);